import { IImagePreview } from 'models/landings.google.model'
import { AppImageOrientation, AppPreviewFileType } from 'root-constants'

export const convertUrlToImgPreview = (url: string): IImagePreview => ({
  id: url,
  url,
  orientation: AppImageOrientation.UNKNOWN,
  fileType: AppPreviewFileType.IMAGE,
})
